(() => {
  if (window.__hboShippingInitialized) return;
  window.__hboShippingInitialized = true;
  const formatter = new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 2 });
  let lastTotal = null;
  let version = 0;
  const amount = (cents) => formatter.format(cents / 100);
  function paint(total) {
    if (!Number.isFinite(total)) return;
    lastTotal = total;
    document.querySelectorAll('[data-hbo-free-shipping]').forEach((root) => {
      const goal = Number(root.dataset.threshold || 150000);
      const remaining = Math.max(0, goal - total);
      const label = remaining > 0
        ? 'Ücretsiz kargo için ' + amount(remaining) + ' TL daha ekleyin!'
        : 'Tebrikler! Ücretsiz kargo kazandınız!';
      const message = root.querySelector('.hbo-shipping__message');
      if (message && message.textContent.trim() !== label) message.textContent = label;
      const fill = root.querySelector('.hbo-shipping__fill');
      if (fill) fill.style.width = Math.max(0, Math.min(100, total / goal * 100)) + '%';
      const bar = root.querySelector('[role="progressbar"]');
      if (bar) bar.setAttribute('aria-valuenow', String(Math.max(0, Math.min(goal, total)) / 100));
    });
  }
  function refresh() {
    const requestVersion = ++version;
    const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    fetch(cartUrl + '.js', { credentials: 'same-origin' })
      .then((response) => { if (!response.ok) throw new Error('Cart unavailable'); return response.json(); })
      .then((cart) => { if (requestVersion === version) paint(Number(cart.total_price)); })
      .catch(() => {});
  }
  function start() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        const total = event && event.cartData && Number(event.cartData.total_price);
        if (Number.isFinite(total)) {
          version++;
          paint(total);
        } else {
          refresh();
        }
      });
    }
    document.addEventListener('cart:updated', refresh);
    const observer = new MutationObserver((records) => {
      if (lastTotal === null) return;
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType === 1 && (node.matches('[data-hbo-free-shipping]') || node.querySelector('[data-hbo-free-shipping]'))) {
            paint(lastTotal);
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();